import * as Yup from 'yup'

export const SignRecoverySchema = Yup.object({
  correo: Yup.string()
    .email('Correo electrónico invalido')
    .required('Requerido')
})
